import React from 'react';
import { Heart } from 'lucide-react';
import { useTheme } from '../ui/ThemeContext';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <footer className={`relative flex-shrink-0 ${isDarkMode
      ? 'bg-gray-900/40 border-t border-white/10 backdrop-blur-md'
      : 'bg-white border-t border-slate-200'
    }`}>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="text-center space-y-1">
          <p className={`text-xs font-light ${isDarkMode
            ? 'text-white/80 drop-shadow-lg'
            : 'text-slate-500'
          }`}>
            © {currentYear} Gineex. {t('footer.allRightsReserved')}
          </p>
          <p className={`text-xs font-light flex items-center justify-center space-x-1 ${isDarkMode
            ? 'text-white/70 drop-shadow-lg'
            : 'text-slate-400'
          }`}>
            <span>{t('footer.madeWith')}</span>
            <Heart className={`w-3 h-3 fill-current ${isDarkMode
              ? 'text-red-400'
              : 'text-red-500'
            }`} />
            <span>{t('footer.inGermany')}</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
